/* ============================================================
   ResetRx — Klaviyo list-subscribe form handler
   ------------------------------------------------------------
   The RX subscribe forms (guide PDF, join/newsletter, footer)
   carry a `data-ajax-submit` endpoint and an `action` pointing at
   Klaviyo's legacy hosted page. That hosted page (/subscriptions/
   subscribe) is deprecated and 405s, so the native target="_blank"
   fallback opens a broken new tab and never subscribes.

   This handler intercepts those forms and submits via fetch() to
   Klaviyo's working /ajax/subscriptions/subscribe endpoint (returns
   JSON, CORS-open). It must stay a "simple" CORS request — only the
   safelisted Content-Type header, no X-Requested-With — because the
   endpoint's Access-Control-Allow-Headers is empty (a preflight
   would fail).

   Success/error is read from the JSON response, not assumed. On
   success the form's controls are hidden and an inline message is
   shown (double opt-in: prompts the user to confirm via email).
   ============================================================ */
(function () {
  'use strict';

  var DEFAULT_SUCCESS = 'Thanks — check your inbox and click the confirmation link to finish.';

  function serialize(form) {
    var params = new URLSearchParams();
    var els = form.querySelectorAll('input[name], select[name], textarea[name]');
    Array.prototype.forEach.call(els, function (el) {
      if (!el.name) return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      params.append(el.name, el.value);
    });
    return params.toString();
  }

  function errorText(data) {
    if (data && data.errors && data.errors.length) {
      return data.errors.map(function (e) {
        return typeof e === 'string' ? e : (e && e.detail) || 'Please try again.';
      }).join(' ');
    }
    return 'Something went wrong. Please try again.';
  }

  function messageEl(form, isError) {
    var cls = isError ? 'rx-form-msg--error' : 'rx-form-msg--success';
    var el = form.querySelector('.' + cls);
    if (!el) {
      el = document.createElement('p');
      el.className = 'rx-form-msg ' + cls;
      el.setAttribute('role', isError ? 'alert' : 'status');
      el.style.margin = '16px 0 0';
      el.style.fontFamily = "'Plus Jakarta Sans', system-ui, sans-serif";
      el.style.fontSize = '15px';
      el.style.lineHeight = '1.5';
      el.style.color = isError ? '#B00020' : 'inherit';
      form.appendChild(el);
    }
    return el;
  }

  function showSuccess(form, text) {
    Array.prototype.forEach.call(form.children, function (c) {
      if (!c.classList || !c.classList.contains('rx-form-msg')) c.style.display = 'none';
    });
    messageEl(form, false).textContent = text;
  }

  function onSubmit(e) {
    var form = e.currentTarget;
    var endpoint = form.getAttribute('data-ajax-submit');
    if (!endpoint) return; // no endpoint: let the browser do whatever it would
    e.preventDefault();

    var email = form.querySelector('input[type="email"], input[name="email"]');
    if (email && !email.checkValidity()) { email.reportValidity(); return; }

    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: serialize(form)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.success) {
          showSuccess(form, form.getAttribute('data-success-message') || DEFAULT_SUCCESS);
        } else {
          messageEl(form, true).textContent = errorText(data);
          if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
        }
      })
      .catch(function () {
        messageEl(form, true).textContent = 'Network error — please try again.';
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
      });
  }

  function init() {
    var forms = document.querySelectorAll('form[data-ajax-submit]:not([data-ajax-skip])');
    Array.prototype.forEach.call(forms, function (form) {
      form.removeAttribute('target'); // neutralize the broken native new-tab fallback
      form.addEventListener('submit', onSubmit);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
